import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation JSON files
import enTranslation from './locales/en.json';
import idTranslation from './locales/id.json';

i18n
  .use(LanguageDetector) // Detects language
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      id: {
        translation: idTranslation,
      },
    },
    lng: 'id', // Default language
    supportedLngs: ['en', 'id'], // Supported languages
    interpolation: {
      escapeValue: false, // React already escapes values
    }
  });

export default i18n;
